import { format } from 'date-fns';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { outdoorlinkJPG } from '@sophocles/utils/encodedImages';

pdfMake.vfs = pdfFonts;

export function createPdf(
  customerName,
  sitegroupName,
  siteName,
  relayLoadName,
  startDate,
  endDate,
  popList,
  isBillboard,
  t,
) {
  // expect immutable list of POPs in the order we want

  function createTableBody(popList) {
    const tableHeader = [
      { text: t('general.date'), style: 'tableHeader' },
      { text: t('pop.relay'), style: 'tableHeader' },
      { text: isBillboard ? t('reports.panel') : t('reports.zone'), style: 'tableHeader' },
      { text: t('general.schedules'), style: 'tableHeader' },
      { text: t('pop.alarms'), style: 'tableHeader' },
      { text: t('general.status'), style: 'tableHeader' },
    ];

    const body = [tableHeader];

    // loop through pops
    popList.forEach(pop => {
      body.push([
        pop.get('report_date'),
        pop.get('relay_number').toString(),
        pop.get('relay_load_name'),
        pop.get('schedules'),
        pop.get('legacy_alarm_string'),
        pop.get('passed') ? { text: t('pop.pass'), style: 'goodRow' } : { text: t('pop.fail'), style: 'badRow' },
      ]);
    });
    return body;
  }

  const dd = {
    header: function () {
      return {
        columns: [
          [
            {
              image: outdoorlinkJPG,
              width: 257,
              height: 45,
              style: { alignment: 'left' },
            },
            {
              style: { fontSize: 10 },
              margin: [0, 5],
              text: `${customerName}\n ${t('pop.plantLabel')} ${sitegroupName}\n ${t('pop.siteLabel')} ${siteName}\n ${
                isBillboard ? t('reports.panel') : t('reports.zone')
              }: ${relayLoadName}`,
            },
          ],
          {
            text: [
              { text: t('pop.reportFor') + ' ' },
              {
                text: format(startDate, 'yyyy-MM-dd'),
                bold: true,
              },
              { text: ' ' + t('pop.to') + ' ' },
              { text: format(endDate, 'yyyy-MM-dd'), bold: true },
            ],
            style: { alignment: 'right', fontSize: 10 },
          },
        ],
        margin: [40, 30],
      };
    },
    footer: function (page, pages) {
      return {
        columns: [
          {
            style: { alignment: 'right', fontSize: 10 },
            columns: [
              { text: t('pop.providedBy') + ' ', margin: [0, 15, 5, 0] },
              {
                image: outdoorlinkJPG,
                width: 228,
                height: 40,
              },
            ],
          },
          {
            width: 180,
            text: [
              t('pop.page') + ' ',
              { text: page.toString(), italics: true },
              ' ' + t('pop.of') + ' ',
              { text: pages.toString(), italics: true },
            ],
            margin: [0, 15, 5, 0],
            style: { alignment: 'right', fontSize: 10 },
          },
        ],
        margin: [40, 0],
      };
    },
    content: [
      { text: t('pop.reportTitle'), style: 'header' },
      {
        style: 'tableExample',
        table: {
          widths: ['auto', 'auto', 'auto', 100, '*', 40],
          headerRows: 1,
          body: createTableBody(popList),
        },
      },
    ],
    pageSize: 'LETTER',
    pageMargins: [40, 150, 40, 60],

    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
        alignment: 'center',
      },
      subheader: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      tableExample: {
        margin: [0, 5, 0, 15],
        fontSize: 10,
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        color: 'black',
        fillColor: 'lightblue',
      },
      goodRow: {
        fillColor: '#3DF640',
      },
      badRow: {
        fillColor: '#FF3232',
      },
    },
    defaultStyle: {},
  };
  pdfMake.createPdf(dd).download('pop-report-' + Date.now() + '.pdf');
}
